import Dexie, { type Table } from 'dexie';
import type {
  TransactionCategory,
  Account,
  TriageTransaction,
  Transaction,
  CategorizationRule,
  Setting,
  Security,
  SecurityTransaction,
  SecurityPriceCache,
  SecurityPerformancePrice,
  SecurityPerformanceMetadata,
  SecurityPerformanceIntradayPrice,
} from '@/types';

class FinanceDatabase extends Dexie {
  categories!: Table<TransactionCategory>;
  accounts!: Table<Account>;
  triageTransactions!: Table<TriageTransaction>;
  transactions!: Table<Transaction>;
  rules!: Table<CategorizationRule>;
  settings!: Table<Setting>;
  securities!: Table<Security>;
  securityTransactions!: Table<SecurityTransaction>;
  securityPriceCache!: Table<SecurityPriceCache>;
  securityPerformancePrices!: Table<SecurityPerformancePrice>;
  securityPerformanceMetadata!: Table<SecurityPerformanceMetadata>;
  securityPerformanceIntradayPrices!: Table<SecurityPerformanceIntradayPrice>;

  constructor() {
    super('TallyDatabase');
    this.version(1).stores({
      categories: 'id',
      accounts: 'id',
      triageTransactions: 'id',
      transactions: 'id',
      rules: 'id',
      settings: 'key',
      securities: 'id',
      securityTransactions: 'id, securityId',
      securityPriceCache: 'id, securityId',
    });
    this.version(2).stores({
      categories: 'id',
      accounts: 'id',
      triageTransactions: 'id',
      transactions: 'id',
      rules: 'id',
      settings: 'key',
      securities: 'id',
      securityTransactions: 'id, securityId',
      securityPriceCache: 'id, securityId',
      securityPerformancePrices: '[securityId+date], securityId, date',
      securityPerformanceMetadata: 'securityId',
    });
    this.version(3).stores({
      categories: 'id',
      accounts: 'id',
      triageTransactions: 'id',
      transactions: 'id',
      rules: 'id',
      settings: 'key',
      securities: 'id',
      securityTransactions: 'id, securityId',
      securityPriceCache: 'id, securityId',
      securityPerformancePrices: '[securityId+date], securityId, date',
      securityPerformanceMetadata: 'securityId',
      securityPerformanceIntradayPrices: '[securityId+timestamp], securityId, timestamp',
    });
  }
}

export const db = new FinanceDatabase();
